// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Users: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 41.1 41.7" enableBackground="new 0 0 41.1 41.7" xmlSpace="preserve">
<path fill="currentColor" d="M28.2,16.6c4.9,0,6.3-5.5,6.3-9.1S31.7,1,28.2,1s-6.3,2.9-6.3,6.5C21.8,11.1,23.1,16.6,28.2,16.6z"/>
<path fill="currentColor" d="M40.2,28.2l-1.7-7.5c-0.1-0.3-0.3-0.5-0.6-0.6c-1-0.5-3.4-1.8-4.8-2.5c-0.2-0.1-0.3-0.1-0.5,0.1
	c-1.1,1-3.2,1.3-4.3,1.4c-0.4,0-0.8,0-1.2,0C26,19,24,18.7,22.8,17.7c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.3,0.1-0.4,0.2v0.1
	c0,3-0.8,6.1-2.6,8.3c0,0,0,0,0.1,0c1.4,0.7,3.9,2,4.8,2.5c0.6,0.3,1.1,0.8,1.4,1.4h13.2C40,30.2,40.7,29.2,40.2,28.2z"/>
<path fill="currentColor" d="M25.7,38.7L24,31.2c-0.1-0.1-0.1-0.2-0.2-0.3s-0.2-0.2-0.3-0.2c-0.2-0.1-0.4-0.2-0.6-0.3
	c-1.2-0.6-3-1.6-4.2-2.2c-0.1,0-0.1,0-0.2,0s-0.2,0-0.3,0.1c-0.8,0.7-2,1-3,1.2c-0.5,0.1-1,0.2-1.3,0.2c-0.2,0-0.4,0-0.6,0
	c-0.2,0-0.4,0-0.6,0c-0.5-0.1-1.3-0.2-2.1-0.4c-0.8-0.2-1.6-0.5-2.2-1C8.2,28.1,8.1,28,8,28c-0.1,0-0.1,0-0.2,0
	c-1.4,0.7-3.9,2-4.8,2.5c-0.3,0.1-0.5,0.3-0.6,0.6L0.6,39c-0.4,0.8,0.2,1.7,1.2,1.7h22.6C25.4,40.7,26.1,39.6,25.7,38.7z"/>
<path fill="currentColor" d="M18.9,14.3c-0.2-0.3-0.5-0.7-0.8-1s-0.6-0.6-0.9-0.8s-0.7-0.4-1.1-0.6c-0.4-0.2-0.8-0.3-1.2-0.4
	c-0.4-0.1-0.8-0.1-1.3-0.1c-3.5,0-6.3,2.9-6.3,6.5S8.6,27,13.6,27c0.7,0,1.4-0.1,1.9-0.4c1.1-0.4,2-1.2,2.7-2.2
	c0.3-0.4,0.5-0.9,0.7-1.4c0.4-1,0.7-2,0.8-3c0.1-0.4,0.1-0.8,0.1-1.3c0-0.3,0-0.6,0-0.9C20,16.6,19.6,15.4,18.9,14.3z"/>
</svg>;
};

export default React.memo(Users);
